import { css } from '@emotion/react'
import {graphql} from "gatsby";
import { chunk } from 'lodash/array'
import { BlogFooter } from '../../components/blog/Footer'
import { PageBreak } from '../../components/blog/PageBreak'
import { Slider } from '../../components/blog/Slider'
import {Body} from "../../components/Body";
import React from "react";
import { Section } from '../../components/content'
import { ArticleListItem } from '../../components/helpCenter/ArticleListItem'
import { CategoryIcon } from '../../components/helpCenter/CategoryIcon'
import { CollectionCard, COLLECTIONS_BREAKEPOINTS } from '../../components/helpCenter/CollectionCard'
import { HelpHeader } from '../../components/helpCenter/Header'
import { HelpArticleCard } from '../../components/helpCenter/HelpArticleCard'
import { SliderTitle } from '../../components/helpCenter/SliderTitle'
import { Colors, eerieBlack, violetBlue } from '../../styles/colors'
import { Spacing } from '../../styles/spacing'
import { Typography } from '../../styles/typography'
import { FuckedUpTypography } from '../../styles/typography.responsive'
import { cssOnlyDesktop, isDesktop } from '../../styles/utils'
import { HeroContainer } from '../helpCenterHomepage/template'
import ImageIcon from '../../images/icons/arrow-right.svg'
const HelpCenterCategory = ({data, pageContext}) => {
  const {
    allCollections: {edges: collections},
    allArticles: {edges: articles},
    mostViewed: {edges: mostViewedArticles } } = data
  const {node: collection} = collections.find(({node}) => node.id__normalized === pageContext.collectionId)
  return (
    <Body dmSans safe={false} FooterComponent={BlogFooter} HeaderComponent={HelpHeader}>
      {/*Hero */}
      <Section backgroundColor={collection.color} noSpacing internalStyle={isDesktop() ? {height: '358px', paddingBottom: '80px'} : {height: '358px', paddingBottom: '72px'}}>
        <HeroContainer >
          <div css={[isDesktop() && Spacing.Flex.row, Spacing.Margin.bottom_16]} >
            <CategoryIcon width={isDesktop() ? 50 : 40} height={isDesktop() ? 50 : 40} src={collection.icon} color={eerieBlack["0"]}/>
            <h2 css={[FuckedUpTypography.heading.h2_700, Colors.Color.eerieBlack0,isDesktop() && Spacing.Margin.left_16]}>{collection.name}</h2>
          </div>
          <span css={[Typography.heading.h5_400, Colors.Color.eerieBlack0]}>{collection.description}</span>
        </HeroContainer>
      </Section>
      <Section internalStyle={isDesktop() ? {} : {paddingTop: '48px'}}>
        <SliderTitle title={'I più recenti'}/>
        <Slider>
          {articles.slice(0,9).map(({node})=> (
            <HelpArticleCard key={node.id} article={node} collection={collection} />
          ))}
        </Slider>
        <SliderTitle title="I più letti"  css={Spacing.Margin.top_48}/>
        <Slider>
          {mostViewedArticles.map(({node}, idx)=> (
            <HelpArticleCard number={idx + 1} key={node.id} article={node} collection={collections} />
          ))}
        </Slider>
        <PageBreak/>
        <SliderTitle title={'Tutti gli articoli'}/>
        <ol className="row" css={Spacing.Layout.cleanList}>
        {articles.map(({node})=> (
          <li className={"col-12 col-sm-6"}>
          <ArticleListItem key={node.id} article={node} collection={collection} />
          </li>
        ))}
        </ol>
        <PageBreak/>
        <SliderTitle title="Argomenti"/>
        <Slider hideNavigation breakpoints={COLLECTIONS_BREAKEPOINTS}>
          {chunk(collections,2).map( (chunk, idx) => {
            const [{node: collectionA }, {node: collectionB} = {}] = chunk
            return (
              <div key={idx}>
                <CollectionCard  {...collectionA}/>
                {collectionB && <>
                  <div css={Spacing.Padding.bottom_16}/>
                  <CollectionCard  {...collectionB}/>
                </>
                }
              </div>)
          })}
        </Slider>
      </Section>
    </Body>
  )
}
export default HelpCenterCategory

export const helpCenterCategoryQuery = graphql`
  query($collectionId: Int!) {
   allCollections(sort: {fields:[order], order:[ASC]}) {
      edges {
        node {
          id__normalized
          name
          color
          icon
          description
          slug
        }
      }
    }
    allArticles(filter: {CollectionId: {eq: $collectionId}}, sort: {fields:[sourceUpdatedAt], order:[DESC]}) {
      edges {
        node {
          id
          title
          description
          slug
        }
      }
    }
    mostViewed: allArticles(filter: {CollectionId: {eq: $collectionId}}, sort: {fields:[viewsCount], order:[DESC]}, limit: 9) {
    edges {
      node {
        id
        title
        description
        CollectionId
        sourceUpdatedAt
        slug
      }
    }
  }
  }
 `
